import { DEFAULT_TEMPLATE_KEY } from '@capital-access/common/utils';
import { EXPORT_OWNERSHIP_ANALYSIS_TEMPLATE_ID_KEY, OWNERSHIP_ANALYSIS_PREDEFINED_TEMPLATE_ID_KEY } from '../constants';
import { ReportType } from '../models/report-type.enum';

export function isNullOrEmptyString(value: any): boolean {
  return value == null || (typeof value === 'string' && value.trim().length === 0);
}

export function getOwnershipAnalysisTemplateId(isExport: boolean = false): number {
  const getStoredOwnershipTemplateId = (key: string): number => Number(localStorage.getItem(key) ?? 0);

  const exportTemplateId = getStoredOwnershipTemplateId(EXPORT_OWNERSHIP_ANALYSIS_TEMPLATE_ID_KEY);
  if (exportTemplateId > 0) return exportTemplateId;

  const defaultTemplateKey = `${ReportType.OwnershipAnalyticsReport}_${DEFAULT_TEMPLATE_KEY}`.toUpperCase();
  const defaultTemplateId = getStoredOwnershipTemplateId(defaultTemplateKey);
  if (defaultTemplateId > 0) return defaultTemplateId;

  if (isExport) {
    return getStoredOwnershipTemplateId(OWNERSHIP_ANALYSIS_PREDEFINED_TEMPLATE_ID_KEY);
  }

  return 0;
}
